import moment from "moment";

export class Period {
  value: string;
  label: string;

  constructor(private dateValue: string, private labelValue: string) {
    this.setValue(dateValue);
    this.setLabel(labelValue);
  }

  setValue(value: string): void {
    this.value = value;
  }

  setLabel(value: string): void {
    this.label = value;
  }

  getValue(): string {
    return this.value;
  }

  getLabel(): string {
    return this.label;
  }

  static getLastMonths(totalMonths: number): Array<Period> {
    const dates = new Array<Period>();
    for (let i = 0; i < totalMonths; i++) {
      var dateValue = moment(new Date()).endOf("month").subtract(i, "month");
      var labelValue = dateValue.format("MMMM") + " de " + dateValue.year();
      const date = new Period(dateValue.format("DDMMYYYY"), labelValue);
      dates.push(date);
    }
    return dates;
  }

  static getLastMonthsWithFixedDay(totalMonths: number, day: number): Array<Period> {
    const dates = new Array<Period>();
    for (let i = 0; i < totalMonths; i++) {
      var dateValue = moment(new Date()).endOf("month").subtract(i, "month");
      if(dateValue.date() > day){
        dateValue = dateValue.date(day);
      }
      var labelValue = dateValue.format("MMMM") + " de " + dateValue.year();
      const date = new Period(dateValue.format("DDMMYYYY"), labelValue);
      dates.push(date);
    }
    return dates;
  }
}
